
export default function DoubleImageText({
    title,
    description,
    handleClick,
    children
}) {
    return (
        <section className="min-h-screen md:h-screen flex flex-col md:flex-row gap-16 md:gap-0 py-16 md:py-0">
            <div className="flex flex-col justify-center px-6 md:px-14 gap-10 md:w-1/2">
                <h2 className="lg:text-5xl text-center md:text-left text-4xl text-mcare-green font-semibold md:drop-shadow-lg text-balance panoragraf-light" 
                data-aos="fade-up" data-aos-duration="1000">
                    {title}
                </h2>

                {description}
                <button
                    onClick={handleClick}
                    id="heroSection"
                    className="progress-button-mcare px-8 py-2 uppercase font-semibold tracking-wider text-center transition duration-300 ease-in-out w-full lg:w-fit">
                    Prenota una visita
                  </button>
            </div>

            {children}
        </section>
    );
}